import { EnvConfiguration } from "./AppConfiguration";

export const development: EnvConfiguration = {
    api: "https://bimids-api-dev.dstudio.be/",
    assets: "https://stdstshareddev.blob.core.windows.net/bimids-assets/",
    canonical: "https://bimids-dev.dstudio.be",
    auth: {
        audience: "https://app-idsplatform-api-dev.azurewebsites.net/",
        domain: "bimids.eu.auth0.com",
        clientId: "8niBsC1pl8qzrcCFRoyQm3aVNXZECLzH",
        logoutTo: `https://${window.location.hostname}`,
        scope: "openid email profile offline_access read:current_user update:current_user_metadata admin:access",
    },
    algolia: {
        appId: "OKRNWEA4OH",
        apiKey: "4527e3ddd4c483ae933b1e9381495de2",
        index: "bimids-dev",
    },
    bimq: {
        clientId: "Buildwise",
        redirectUri: `https://${window.location.hostname}/bimq-auth-callback`,
        authorizeEndpoint: "https://server.bim-q.de/oauth/authorize",
    },
    sentry: {
        dsn: "https://93ed3e0cbdc54aad8409e9a8d6c3b321@o399431.ingest.sentry.io/4504604448129024",
        env: "development",
        sampleRate: 1.0,
        enableLogs: false,
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 0.0,
    },
    gtm: {
        id: "GTM-56KDNGB",
    },
};
